<template>
	<div class="filters-box">
		<div class="filters-box-row" :style="collapse ? 'height: 42px' : ''">
			<div class="data-picker-box">
				<span>退单时间：</span>
				<el-date-picker
					v-model="dateValue"
					:clearable="false"
					size="small"
					type="datetimerange"
					align="right"
					style="width:405px"
					popper-class="filter-time-popper"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:default-time="['00:00:00', '23:59:59']"
					format='yyyy-MM-dd HH:mm'
					value-format='yyyy-MM-dd HH:mm'>
				</el-date-picker>
			</div>
			<div class="order-name-box">
				<span>商品名称：</span>
				<el-input v-model="pname" placeholder="请输入商品名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-NO-box">
				<span>退单编号：</span>
				<el-input v-model="refundnumber" placeholder="请输入退单编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-type-box">
				<span>退单状态：</span>
				<el-select v-model="refundstatus" multiple collapse-tags placeholder="请选择退单状态" class="order-type-select" size="small">
					<!-- <el-option label="全部" value="全部"></el-option> -->
					<el-option label="待处理" value="待处理"></el-option>
					<el-option label="已同意" value="已同意"></el-option>
					<el-option label="退货完成" value="退货完成"></el-option>
				</el-select>
			</div>
			<div class="order-name-box">
				<span>客户名称：</span>
				<el-input v-model="customerName" placeholder="请输入客户名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-type-box">
				<span>客户类别：</span>
				<el-select v-model="customercategoryid" filterable multiple collapse-tags class="order-type-select" size='small'>
					<!-- <el-option value="0" label="全部"></el-option> -->
					<el-option v-for="item in customList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
				</el-select>
			</div>
			<div class="order-type-box">
				<span>店铺名称：</span>
				<el-select v-model="shopids" class="order-type-select" collapse-tags multiple size='small'>
					<el-option v-for="item in shopList" :value="item.id" :label="item.name" :key="item.id"></el-option>
				</el-select>
			</div>
			<div class="order-type-box">
				<span>店铺级大类：</span>
				<el-select v-model="bigcategoryid" multiple collapse-tags placeholder="请选择店铺级大类" class="order-type-select" size="small" @change="bcChange" @remove-tag="removeBigCategoryid">
					<!-- <el-option value="0" label="全部"></el-option> -->
					<template v-for="(item) in bc">
						<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id"/>
					</template>
				</el-select>
			</div>
			<div class="order-type-box" v-if="bigcategoryview === 1">
				<span>店铺级小类：</span>
				<el-select v-model="smallcategoryid" multiple collapse-tags placeholder="请选择店铺级小类" class="order-type-select" size="small">
					<!-- <el-option value="0" label="全部"></el-option> -->
					<template v-for="(item) in sc">
						<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
					</template>
				</el-select>
			</div>
			<div class="order-name-box">
				<span>商品编号：</span>
				<el-input v-model="pcode" placeholder="请输入商品编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>第三方编号：</span>
				<el-input v-model="matchCode" placeholder="请输入第三方编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>客户编号：</span>
				<el-input v-model="customerCode" placeholder="请输入客户编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>规格：</span>
				<el-input v-model="spec" placeholder="请输入规格名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>规格编号：</span>
				<el-input v-model="specCode" placeholder="请输入规格编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
		</div>
		<div class="collapse-box">
			<el-button size="small" type="text" class="btn" style="color:var(--fx-primary-color);margin-left:10px" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:var(--fx-primary-color);"/>
			</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'FiltersBox',
	data () {
		return {
			shopids: [],
			shopList: [],
			refundnumber: '',
			pname: '',
			dateValue: [],
			dateValue1: [],
			dateValue2: [],
			customerName: '',
			matchCode: '',
			customerCode: '',
			pcode: '',
			bigcategoryview: null,
			bigcategoryid: [],
			smallcategoryid: [],
			bc: [],
			sc: [],
			refundstatus: [],
			customercategoryid: [],
			customList: [],
			spec: '',
			specCode: '',
			collapse: true,
			memo: ''
		}
	},
	created () {
		this.checkSmallCategory()
		this.getBigCategory()
		this.getCustomer()
		this.initFilters()
		this.getShopList()
	},
	methods: {
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
			})
		},
		bcChange (value) {
			if (this.bigcategoryview === 1 && value.length > 0) {
				if (value.length > this.bigcategoryidLength) {
					this.bigcategoryidLength = value.length
				} else {
					this.smallcategoryid = []
				}
				this.getSmalCategory()
			}	else {
				this.sc = []
				this.smallcategoryid = []
				this.getSmalCategory()
			}
		},
		removeBigCategoryid () {
			this.smallcategoryid = []
		},
		getSmalCategory () {
			let params = {
				pids: this.bigcategoryid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		// 是否开启小类
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview
			})
		},
		inputEnterHandle () {
			this.$emit('inputEnter')
		},
		getCustomer () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		initFilters () {
			if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
				let Params = decodeURI(this.$route.query.queryParams)
				let queryParams = this.$fxUtils.JSONparse(Params)
				if (queryParams.startDate && queryParams.endDate) {
					this.dateValue = [queryParams.startDate.data, queryParams.endDate.data]
				} else {
					this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
				}
				if (queryParams.pname) {
					this.pname = queryParams.pname.data
				}
				if (queryParams.refundnumber) {
					this.refundnumber = queryParams.refundnumber.data
				}
				if (queryParams.refundstatus) {
					this.refundstatus = queryParams.refundstatus.data.split(',')
				}
				if (queryParams.customername) {
					this.customerName = queryParams.customername.data
				}
				if (queryParams.customercategoryid) {
					this.customercategoryid = queryParams.customercategoryid.data.split(',')
				}
				if (queryParams.shopid) {
					this.shopids = queryParams.shopid.data.split(',')
				}
				if (queryParams.bigcategoryid) {
					this.bigcategoryid = queryParams.bigcategoryid.data.split(',')
					this.getSmalCategory()
				}
				if (queryParams.smallcategoryid) {
					this.smallcategoryid = queryParams.smallcategoryid.data.split(',')
				}
				if (queryParams.pcode) {
					this.pcode = queryParams.pcode.data
				}
				if (queryParams.matchcode) {
					this.matchCode = queryParams.matchcode.data
				}
				if (queryParams.customerCode) {
					this.customerCode = queryParams.customerCode.data
				}
				if (queryParams.spec) {
					this.spec = queryParams.spec.data
				}
				if (queryParams.speccode) {
					this.specCode = queryParams.speccode.data
				}
			} else {
				this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
			}
		},
		clearSearch () {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
			this.refundnumber = ''
			this.customerName = ''
			this.pcode = ''
			this.pname = ''
			this.bigcategoryid = []
			this.smallcategoryid = []
			this.refundstatus = []
			this.customercategoryid = []
			this.shopids = []
			this.spec = ''
			this.specCode = ''
			this.customerCode = ''
			this.matchCode = ''
			this.memo = ''
		},
		getFiltersDate () {
			if (this.dateValue.length > 0) {
				return [
					{ name: 'startDate', field: 'createDate', value: `${this.dateValue[0]}:00`, 'op': 'ge', type: 'filtersParams' },
					{ name: 'endDate', field: 'createDate', value: `${this.dateValue[1]}:59`, 'op': 'le', type: 'filtersParams' }
				]
			}
		},
		getFiltersParams () {
			let filtersParams = []
			let cParams = []
			if (+this.dateValue === 0 ||
				this.dateValue === null ||
				this.dateValue === undefined) {
				filtersParams = []
			} else {
				filtersParams = [
					{ field: 'startDate', data: `${this.dateValue[0]}:00`, 'op': 'ge' },
					{ field: 'endDate', data: `${this.dateValue[1]}:59`, 'op': 'le' }
				]
			}
			// let typeObj = { 'field': 'type', 'data': '0', 'op': 'eq', name: '类型' }
			// filtersParams.push(typeObj)
			if (this.bigcategoryid.length !== 0) {
				let bigcategoryid = { 'field': 'bigcategoryid', 'data': this.bigcategoryid.join(','), 'op': 'in' }
				filtersParams.push(bigcategoryid)
			}
			if (this.smallcategoryid.length !== 0) {
				let smallcategoryid = { 'field': 'smallcategoryid', 'data': this.smallcategoryid.join(','), 'op': 'in' }
				filtersParams.push(smallcategoryid)
			}
			if (this.shopids.length > 0) {
				let data = this.shopids.join(',')
				let shopObj = { 'field': 'shopid', 'data': data, 'op': 'in' }
				filtersParams.push(shopObj)
			}
			if (this.customercategoryid.length !== 0) {
				let customercategoryid = { 'field': 'customercategoryid', 'data': this.customercategoryid.join(','), 'op': 'in' }
				filtersParams.push(customercategoryid)
			}
			if (this.customerName) {
				let customerNameObj = { 'field': 'customername', 'data': this.customerName, 'op': 'cn' }
				filtersParams.push(customerNameObj)
			}
			if (this.customerCode) {
				let customerCode = { 'field': 'customerCode', 'data': this.customerCode, 'op': 'cn' }
				filtersParams.push(customerCode)
			}
			if (this.memo) {
				let memoObj = { 'field': 'detailmemo', 'data': this.memo, 'op': 'cn' }
				filtersParams.push(memoObj)
			}
			if (this.refundnumber) {
				let orderNoObj = { 'field': 'refundnumber', 'data': this.refundnumber, 'op': 'cn' }
				filtersParams.push(orderNoObj)
			}
			if (this.pname) {
				let pnameObj = { 'field': 'pname', 'data': this.pname, 'op': 'cn' }
				filtersParams.push(pnameObj)
			}
			if (this.pcode) {
				let pcodeObj = { 'field': 'pcode', 'data': this.pcode, 'op': 'cn' }
				filtersParams.push(pcodeObj)
			}
			if (this.matchCode) {
				let matchCode = { 'field': 'matchcode', 'data': this.matchCode, 'op': 'cn' }
				filtersParams.push(matchCode)
			}
			if (this.spec) {
				let specObj = { 'field': 'spec', 'data': this.spec, 'op': 'cn' }
				filtersParams.push(specObj)
			}

			if (this.specCode) {
				let specCodeObj = { 'field': 'speccode', 'data': this.specCode, 'op': 'cn' }
				filtersParams.push(specCodeObj)
			}
			if (this.refundstatus.length !== 0) {
				let refundstatus = { 'field': 'refundstatus', 'data': this.refundstatus.join(','), 'op': 'in' }
				cParams.push(refundstatus)
			}

			return {
				filtersParams,
				cParams
			}
		},
		handleCollapse () {
			this.collapse = !this.collapse
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box {
	width:100%
	display: flex
	.filters-box-row {
		flex: 1
		display:flex
		flex-wrap: wrap
		overflow: hidden
		// margin-bottom: 10px
		&>div {
			margin-bottom: 10px
			&>span {
				display: inline-block;
				width: 105px;
				text-align: right
			}
		}
		.data-picker-box {
			// margin-right:10px
		}
		.order-type-box {
			// margin-right:10px
			.order-type-select {
				width:150px
			}
		}
		.order-NO-box, .order-name-box{
			// margin-right: 10px;
			.order-input {
				width:150px
			}
		}
	}
	.collapse-box {
		width: 80px;
		margin-left: 10px
		flex-shrink: 0
	}
}
</style>
<style lang="stylus">
.filter-time-popper {
	.el-button--text {
		display: none
	}
}
</style>
